module.exports = __webpack_public_path__ + "static/media/url_102.4bfcb07d.ico";